import { useEffect, useRef } from 'react';
export var ActivityType;
(function (ActivityType) {
    ActivityType["SCROLL"] = "scroll";
    ActivityType["MOUSEMOVE"] = "mousemove";
    ActivityType["CLICK"] = "click";
})(ActivityType || (ActivityType = {}));
export var UserEngagementPinger = function (props) {
    var initialActivities = new Set();
    var loggedActivitiesRef = useRef(initialActivities);
    var updateActivities = function (activity) { return loggedActivitiesRef.current.add(activity); };
    var handleClick = function () { return updateActivities(ActivityType.CLICK); };
    var handleScroll = function () { return updateActivities(ActivityType.SCROLL); };
    var handleMousemove = function () { return updateActivities(ActivityType.MOUSEMOVE); };
    useEffect(function () {
        window.addEventListener(ActivityType.CLICK, handleClick);
        window.addEventListener(ActivityType.SCROLL, handleScroll);
        window.addEventListener(ActivityType.MOUSEMOVE, handleMousemove);
        return function () {
            window.removeEventListener(ActivityType.CLICK, handleClick);
            window.removeEventListener(ActivityType.SCROLL, handleScroll);
            window.removeEventListener(ActivityType.MOUSEMOVE, handleMousemove);
        };
    }, []);
    useEffect(function () {
        var interval = setInterval(function () {
            props.onPing(Array.from(loggedActivitiesRef.current));
            loggedActivitiesRef.current.clear();
        }, props.pingInterval);
        return function () { return clearInterval(interval); };
    }, []);
    return null;
};
//# sourceMappingURL=index.js.map